import type { schemaType } from '~/modules/api/rurality/v2/cottages/recommended/schema'
import type { CottageContactDealRecommended } from '../../entities/CottageContactDealRecommended'

export const useToCottageContactDealRecommended = () => {
  const fromRuralityCottageRecommended = (
    data: schemaType = [],
  ): CottageContactDealRecommended => {
    const entityData: CottageContactDealRecommended = (
      Array.isArray(data) ? data : []
    ).map(item => ({
      provincename: item.provinceName,
      villagename: item.villageName,
      image: {
        sources: {
          url: item.image,
        },
        alt: item.provinceName,
      },
      url: item.url,
      maxcapacity: item.maxCapacity,
      rating: item.rating,
      priceaverage: item.priceAverage,
      pricesummary: item.priceSummary,
    }))

    return entityData
  }

  return { fromRuralityCottageRecommended }
}
